import styles from "./FolderView.module.css";

const FolderView = () => {
  return (
    <div className={`generic-page`}>
      <h1>
        Folder View is a P1 feature, scheduled to be added in the next update
      </h1>
    </div>
  )
}

export default FolderView